<template>
  <div class="imgwrap">
    <img class="img" src="https://udp-dm-app.zeekrlife.com/md/resource/get/e24a7e3343ac47c39ad522415b3eb70a" />
    <img class="img" src="https://udp-dm-app.zeekrlife.com/md/resource/get/36b0a7891c86450ebbc16ffbb735cdde" />
    <img class="img" src="https://udp-dm-app.zeekrlife.com/md/resource/get/1da651b2053e4d70ac584eabedbf6cd3" />
    <img class="img" src="https://udp-dm-app.zeekrlife.com/md/resource/get/af043c8497a740b693413654c529bff4" />
  </div>
</template>
<style scoped>
  .imgwrap {
    width: 100%;
  }
  img.img {
    width: 100%;
    vertical-align: middle;
  }
</style>
